import React from "react";
import { Outlet } from "react-router-dom";

const Setting = () => {
  return (
    <section className="profile">
      <h1 className="bg-white p-3">
        Settings <hr />
      </h1>
    </section>
  );
};

export default Setting;
